import React, { FC } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Dispatch, iRootState } from '../../../store';
import Icon from '../../../components_/Icon';
import Tooltip from '../../../components_/Tooltip';
import { EditPlanMode } from '../../../models/types';
import ImageOverlay from './ImageOverlay';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { guids, paths } from '../../Root/paths';
import isSatisfied from '../../../utils/isSatisfied';
import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const useStyles = makeStyles(({ spacing }) => ({
  edit: {
    position: 'absolute',
    top: 10,
    left: 462,
    zIndex: 1000
  },
  rotate: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1000
  },
  translate: {
    position: 'absolute',
    top: 60,
    right: 10,
    zIndex: 1000
  },
  scale: {
    position: 'absolute',
    top: 110,
    right: 10,
    zIndex: 1000
  },
  lock: {
    position: 'absolute',
    top: 160,
    right: 10,
    zIndex: 1000
  }
}));

const mapState = (state: iRootState) => ({
  mapId: state.infrastructureMap.map.id,
  editPlan: state.infrastructureMap.editPlan,
  editPlanMode: state.infrastructureMap.editPlanMode,
  isGeo: state.infrastructureMap.layers.isGeo,
  rights: state.securable.data,
  isAllPlans: state.infrastructureMap.map.id === 'all'
});

const mapDispatch = (dispatch: any) => {
  const d = dispatch as Dispatch;

  return {
    setEditPlan: d.infrastructureMap.setEditPlan,
    setEditPlanMode: d.infrastructureMap.setEditPlanMode
  };
};

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

type IProps = connectedProps;

const EditPlan: FC<IProps> = ({
  setEditPlan,
  editPlan,
  setEditPlanMode,
  editPlanMode,
  mapId,
  isGeo,
  rights,
  isAllPlans
}) => {
  const classes = useStyles();
  const history = useHistory();
  // tslint:disable-next-line:prettier
  const isPlaneCreate = useRouteMatch(paths.map.office.plan.create)?.isExact;
  const isPlaneUpdate = useRouteMatch(paths.map.office.plan.edit())?.isExact;

  const handleClick = () => () => {
    history.push(paths.map.office.plan.edit(mapId));
  };

  const handleEdit = (mode: EditPlanMode) => () => {
    setEditPlanMode(mode);
  };

  const checkAccess = isSatisfied(
    { ...{ uid: guids.map.office.plan.edit() }, ...{ action: 'Visibility' } },
    rights
  );

  return (
    <>
      <ImageOverlay mode={editPlanMode} /> {/* План */}
      {checkAccess &&
        (!editPlan ? (
          <>
            <Grid className={classes.edit}>
              <Tooltip size="l" label="Редактировать план">
                <Button
                  icon={<EditOutlined style={{ fontSize: 22 }} />}
                  disabled={!isGeo || !Boolean(mapId) || isAllPlans}
                  key={'isGeo'}
                  size={'large'}
                  onClick={handleClick()}
                  variant="outlined"
                />
              </Tooltip>
            </Grid>
          </>
        ) : (
          <>
            <Grid className={classes.rotate}>
              <Tooltip size="l" label="Повернуть план" placement="left">
                <Button
                  icon={<Icon name="replay" size="m" />}
                  key={'rotate'}
                  size={'large'}
                  onClick={handleEdit(EditPlanMode.Rotate)}
                  variant={editPlanMode === EditPlanMode.Rotate ? 'solid' : undefined}
                  color={editPlanMode === EditPlanMode.Rotate ? 'primary' : undefined}
                />
              </Tooltip>
            </Grid>
            <Grid className={classes.translate}>
              <Tooltip size="l" label="Переместить план" placement="left">
                <Button
                  icon={<Icon name="translate" size="m" />}
                  key={'translate'}
                  size={'large'}
                  onClick={handleEdit(EditPlanMode.Translate)}
                  variant={editPlanMode === EditPlanMode.Translate ? 'solid' : undefined}
                  color={editPlanMode === EditPlanMode.Translate ? 'primary' : undefined}
                />
              </Tooltip>
            </Grid>
            <Grid className={classes.scale}>
              <Tooltip size="l" label="Масштабировать план" placement="left">
                <Button
                  icon={<Icon name="scale" size="m" />}
                  key={'scale'}
                  size={'large'}
                  onClick={handleEdit(EditPlanMode.Scale)}
                  variant={editPlanMode === EditPlanMode.Scale ? 'solid' : undefined}
                  color={editPlanMode === EditPlanMode.Scale ? 'primary' : undefined}
                />
              </Tooltip>
            </Grid>
            <Grid className={classes.lock}>
              <Tooltip size="l" label="Зафиксировать план" placement="left">
                <Button
                  icon={<Icon name="lock" size="m" />}
                  key={'lock'}
                  size={'large'}
                  onClick={handleEdit(EditPlanMode.Lock)}
                  variant={editPlanMode === EditPlanMode.Lock ? 'solid' : undefined}
                  color={editPlanMode === EditPlanMode.Lock ? 'primary' : undefined}
                />
              </Tooltip>
            </Grid>{' '}
          </>
        ))}
    </>
  );
};

const withConnect = connect(mapState, mapDispatch);

export default withConnect(EditPlan);
